import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

import InDmCardButton, { InDmCardButtonProps } from '@/client/components/_atoms/in_dm_card_button'
import InDmImage from '@/client/components/_atoms/in_dm_image'
import { sanitizeHttpUrl } from '@/client/utils/string'

interface Props {
  title: string
  subtitle: string | null
  url: string | null
  mediaUrl: string
  cardButtons?: InDmCardButtonProps[]
}

export default /*#__PURE__*/_defineComponent({
  __name: 'InDmCard',
  props: {
    title: null,
    subtitle: null,
    url: null,
    mediaUrl: null,
    cardButtons: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { title: string, subtitle: string | null, url: string | null, mediaUrl: string, cardButtons: InDmCardButtonProps[] };



const safeUrl = computed(() => sanitizeHttpUrl(props.url))
const linkTag = computed(() => (safeUrl.value ? 'a' : 'div'))
const linkAttrs = computed(() =>
  safeUrl.value ? { href: safeUrl.value, target: '_blank', rel: 'noopener noreferrer' } : {}
)

return { __sfc: true,props, safeUrl, linkTag, linkAttrs, InDmCardButton, InDmImage }
}

})